import { render } from "./docFileUploader.vue?vue&type=template&id=3a73a43a&scoped=true"
import script from "./docFileUploader.vue?vue&type=script&lang=js"
export * from "./docFileUploader.vue?vue&type=script&lang=js"

import "./docFileUploader.vue?vue&type=style&index=0&id=3a73a43a&scoped=true&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a73a43a"]])

export default __exports__